<template>
  <el-card>
    <section>
      <!--工具条-->
      <el-row>
        <el-col :span="24" class="form-line">
          <el-form size="small" :inline="true">
            <el-form-item label="机构管理">
              <el-input v-model="filterText" placeholder="请输入机构"></el-input>
            </el-form-item>
            <!--<div style="float: right">-->
              <!--<el-form-item>-->
                <!--<el-button-group>-->
                  <!--<el-button type="primary" @click="handleAdd(null)">新增一级机构</el-button>-->
                <!--</el-button-group>-->
              <!--</el-form-item>-->
            <!--</div>-->
          </el-form>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="custom-tree-container">
            <div class="block">
              <el-tree
                :data="deptData"
                node-key="id"
                :filter-node-method="filterNode"
                :expand-on-click-node="false"
                :props="treeProps"
                ref="tree">
                <template #default="{ node, data }">
                  <span class="custom-tree-node">
                    <span>{{ node.label }}</span>
                    <span>
                      <span style="padding-right: 10px">
                        <el-link type="primary" :underline="false" @click="handleAdd(node)">新增子机构</el-link>
                      </span>
                      <span style="padding-right: 10px">
                        <el-link type="primary" :underline="false" @click="edit(node)">编辑</el-link>
                      </span>
<!--                      <span>-->
<!--                        <el-link type="primary" v-if="data.unDelFlag !== 1" :underline="false" @click="handleDel(data)">删除</el-link>-->
<!--                      </span>-->
                    </span>
                  </span>
                </template>
              </el-tree>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card">
            <el-form label-width="120px" size="small" :model="editForm" :rules="editFormRules" ref="editForm">
              <el-form-item label="父级机构">
                <el-input v-model="editForm.parentName" :readonly="true"></el-input>
              </el-form-item>
              <el-form-item label="机构名称" prop="deptName">
                <el-input v-model="editForm.deptName" maxlength="50" placeholder="请输入机构名称"></el-input>
              </el-form-item>
              <el-form-item label="是否直属机构" prop="isMainFlag">
                <el-radio-group v-model="editForm.isMainFlag" size="mini">
                  <el-radio :label="1" >是</el-radio>
                  <el-radio :label="2" >否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="经度" v-if="editForm.isMainFlag === 2">
                <el-input v-model="editForm.lon" placeholder="请输入经度"></el-input>
              </el-form-item>
              <el-form-item label="维度" v-if="editForm.isMainFlag == 2">
                <el-input v-model="editForm.lat" placeholder="请输入维度"></el-input>
              </el-form-item>
              <el-form-item label="机构排序" prop="sort">
                <el-input v-model="editForm.sort" placeholder="请输入机构排序" type="number"></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-button style="float: right" size="small" type="primary" @click="addSubmit">确认</el-button>
              </el-form-item>
            </el-form>
          </el-card>
        </el-col>
      </el-row>

    </section>
  </el-card>
</template>

<script>

import { doPost } from '../../api/api'
let id = 1000
export default {
  data () {
    var validateAmount = (rule, value, callback) => {
      if (!value) {
        return callback()
      } else if (!(/(^[1-9]\d*$)/.test(value)) || value > this.depositAmount) {
        return callback(new Error(`请输入1-${this.depositAmount}范围的正整数`))
      } else {
        return callback()
      }
    }
    return {
      depositAmount: 9999,
      treeProps: { label: 'deptName', children: 'sonList' },
      deptData: [],
      filterText: '',
      editForm: {
        systemFlag: 'service-mdinfo',
        level: 1,
        showFlag: 1,
        parentName: '',
        parentId: '',
        isMainFlag: '',
        lon: '',
        lat: ''
      },
      filters: {
        systemFlag: 'service-mdinfo',
        realName: ''
      },
      listLoading: false,
      editFormRules: {
        deptName: [
          { required: true, message: '请输入机构名称', trigger: 'blur' }
        ],
        isMainFlag: [
          { required: true, message: '请选择是否直属机构', trigger: 'blur' }
        ],
        sort: [
          { validator: validateAmount, trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    filterText (val) {
      this.$refs.tree.filter(val)
    }
  },
  methods: {
    append (data) {
      const newChild = { id: id++, label: 'testtest', children: [] }
      if (!data.children) {
        data.children = []
      }
      data.children.push(newChild)
      this.data = [...this.data]
    },

    edit (data) {
      console.log(data)
      this.editForm = data.data
      this.editForm.parentName = data.parent.data.deptName
    },

    remove (node, data) {
      const parent = node.parent
      const children = parent.data.children || parent.data
      const index = children.findIndex(d => d.id === data.id)
      children.splice(index, 1)
      this.data = [...this.data]
    },
    filterNode (value, data) {
      if (!value) return true
      return data.deptName.indexOf(value) !== -1
    },
    // 获取机构树形结构
    getDeptList () {
      this.listLoading = true
      doPost('/dept/getSysDeptTree', this.filters).then((res) => {
        console.log(res.result)
        this.deptData = res.result
        console.log(this.deptData)
        this.listLoading = false
      })
    },
    // 删除
    handleDel: function (data) {
      console.log(data)
      this.$confirm('确认删除' + data.deptName + '吗?', '提示', {
        type: 'warning'
      }).then(() => {
        this.listLoading = true
        var para = { id: data.id }
        doPost('/dept/delete', para).then((res) => {
          this.listLoading = false
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getDeptList()
        })
      }).catch(() => {

      })
    },
    // 显示新增界面
    handleAdd: function (data) {
      // 初始化editForm
      this.editForm = {
        level: 1,
        showFlag: 1
      }
      if (data != null) {
        this.editForm.level = data.data.level + 1
        this.editForm.parentId = data.data.id
        this.editForm.parentName = data.data.deptName
      }
      console.log(this.editForm)
    },
    // 新增
    addSubmit: function () {
      console.log(this.editForm)
      if (this.editForm.isMainFlag === 2) {
        if (this.editForm.lon === '' || this.editForm.lon.trim() === '') {
          this.$message({
            message: '经度不能为空',
            type: 'error'
          })
          return
        }
        if (this.editForm.lat === '' || this.editForm.lat.trim() === '') {
          this.$message({
            message: '维度不能为空',
            type: 'error'
          })
          return
        }
      }
      delete this.editForm.children
      delete this.editForm.sonList
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {}).then(() => {
            this.listLoading = true
            doPost('/dept/saveOrUpdate', this.editForm).then((res) => {
              console.log(res.result)
              this.editForm.id = res.result.id
              this.$message({
                message: '更新成功',
                type: 'success'
              })
              this.getDeptList()
              this.listLoading = false
            })
          })
        }
      })
    }
  },
  mounted () {
    this.getDeptList()
  }
}

</script>

<style scoped>
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
</style>
